import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

const HelperWrapper = (props: React.HTMLProps<HTMLDivElement>) => {
  const { className, children, ...rest } = props;

  return (
    <div className={cx(styles[toCamelCase('textField', 'helperTextWrapper')], className)} {...rest}>
      {children}
    </div>
  );
};

export default HelperWrapper;
